import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { useRef, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import AuthService from '../../service/AuthService';
import { Messages } from 'primereact/messages';
import { InputText } from 'primereact/inputtext';
import { classNames } from 'primereact/utils';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import '../../components/estilo.css';

export const Resetear = ({ toast }) => {

    const defaultValues = {
        nombre: '',
        email: ''
    }
    const { control, formState: { errors }, handleSubmit, reset } = useForm({ defaultValues });
    const [dialogRecordar, setDialogRecordar] = useState(false);
    const [load, setLoad] = useState(false);
    const authService = new AuthService();
    const message = useRef();

    const showDialog = () => {
        reset(defaultValues);
        setDialogRecordar(true);
    }

    const getFormErrorMessage = (name) => {
        return errors[name] && <small className="p-error"><br />{errors[name].message}</small>
    };

    const onSubmit = (data) => {
        setLoad(true);
        authService.reset(data).then(res => {
            setLoad(false);
            toast.current.show({ severity: 'success', summary: 'Clave enviada', detail: res.data.message });
            setDialogRecordar(false);
        }).catch(error => {
            setLoad(false);
            try {
                message.current.show({ severity: 'error', content: error.response.data.message });
            } catch (err) {
                message.current.show({ severity: 'error', content: 'Error al ingresar. Consulte al administrador' });
            }
        });
    }

    return (
        <>
            <Button label="Clic aquí." className="p-button-link" onClick={showDialog} />
            <Dialog visible={dialogRecordar} header="Recuperar Contraseña" modal className="p-fluid modal-ssize dialog-personalizado" onHide={e => setDialogRecordar(false)} style={{ width: '400px' }}>
                <Messages ref={message} />
                <form onSubmit={handleSubmit(onSubmit)} className="p-fluid">
                    <div className="field mb-4">
                        <label htmlFor="nombre" className="font-semibold mb-1 block">
                            Nombre de usuario*
                        </label>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-id-card" />
                            <Controller name="nombre" control={control} rules={{
                                required: 'Número de identificación es requerido.',
                                maxLength: { value: 100, message: 'Máximo 100 caracteres' },
                                minLength: { value: 4, message: 'Mínimo 4 caracteres' }
                            }}
                                render={({ field, fieldState }) => (
                                    <InputText id={field.nombre} {...field} autoFocus className={classNames({ 'p-invalid': fieldState.isDirty })} placeholder='Nombre con el que ingresa al sistema.' />
                                )} />
                        </IconField>
                        {getFormErrorMessage('nombre')}
                    </div>

                    <div className="field mb-4">
                        <label htmlFor="email" className="font-semibold mb-1 block">
                            Correo electrónico*
                        </label>
                        <IconField iconPosition="left">
                            <InputIcon className="pi pi-envelope" />
                            <Controller name="email" control={control}
                                rules={{ required: 'Correo electrónico es requerido.', pattern: { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i, message: 'Correo electrónico no válido. E.g. example@email.com' } }}
                                render={({ field, fieldState }) => (
                                    <InputText id={field.name} {...field} className={classNames({ 'p-invalid': fieldState.isDirty })} placeholder='Correo electrónico asociado a su cuenta.' />
                                )} />
                        </IconField>
                        {getFormErrorMessage('email')}
                    </div>

                    <Button type="submit" label="Resetear contraseña" icon="pi pi-refresh" className="mt-2 w-full" loading={load} />
                </form>
            </Dialog>
        </>
    )
}
